import { AlertTriangle } from "lucide-react";

/** DHAN token expiry banner — warns before the daily 24h blackout / on expiry.
 *  Rotation happens via the single "Update token" button on the DHAN broker strip. */
export const DhanTokenBanner = ({ dhanToken }) => {
  if (!dhanToken?.has_token) return null;
  const warn = dhanToken.expired || (dhanToken.hours_left != null && dhanToken.hours_left < 12);
  if (!warn) return null;
  return (
    <div
      className={`mt-2 flex items-center gap-2 border px-3 py-1.5 ${
        dhanToken.expired ? "border-[#EF4444]/50 bg-[#EF4444]/10" : "border-[#F59E0B]/50 bg-[#F59E0B]/10"
      }`}
      data-testid="admin-dhan-token-banner"
    >
      <AlertTriangle className={`h-3.5 w-3.5 shrink-0 ${dhanToken.expired ? "text-[#EF4444]" : "text-[#F59E0B]"}`} />
      <span className={`text-[10px] uppercase tracking-widest font-mono truncate ${dhanToken.expired ? "text-[#EF4444]" : "text-[#F59E0B]"}`}>
        {dhanToken.expired
          ? `DHAN token EXPIRED ${Math.abs(dhanToken.hours_left ?? 0).toFixed(0)}h ago — use "Update token" on the DHAN strip below`
          : `DHAN token expires in ${dhanToken.hours_left?.toFixed(1)}h — use "Update token" on the DHAN strip below`}
      </span>
    </div>
  );
};
